import { Button, Dialog, DialogContent, DialogHeader, DialogTitle } from '@massilia/ui'
import { MailIcon, MapPin, PhoneIcon } from 'lucide-react'

import { AGENCY_ADDRESS, AGENCY_EMAIL, AGENCY_PHONE } from '@/lib/constants/agency'

import { CopiableContactField } from './copiable-contact-field'

export function FlightDateWarningModal({
  isModalOpen,
  setIsModalOpen,
}: {
  isModalOpen: boolean
  setIsModalOpen: (isModalOpen: boolean) => void
}) {
  return (
    <Dialog onOpenChange={setIsModalOpen} open={isModalOpen}>
      <DialogContent className="max-h-[calc(100vh-2rem)] gap-6 overflow-y-auto rounded-2xl bg-white p-4 sm:p-8">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold">
            Votre départ est dans moins de 5 jours, veuillez contacter l&apos;agence pour la
            réservation de votre billet.
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-6">
          <CopiableContactField icon={PhoneIcon} label="Téléphone" value={AGENCY_PHONE} />
          <CopiableContactField icon={MailIcon} label="Adresse email" value={AGENCY_EMAIL} />
          <CopiableContactField icon={MapPin} label="Adresse" value={AGENCY_ADDRESS} />
        </div>
        <Button
          className="bg-brand-600 hover:bg-brand-800 px-8 py-2 text-white"
          onClick={() => {
            setIsModalOpen(false)
          }}
        >
          Fermer
        </Button>
      </DialogContent>
    </Dialog>
  )
}
